import Header from '../components/Header';
import Footer from '../components/Footer';
import { HowItWorks } from '../components/HowItWorks';

export default function HowItWorksPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 pt-10">
        <div className="eyebrow">Guide</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold mt-1">Comment ça marche</h1>
        <div className="gold-line mt-5 mb-2" />
      </div>
      <HowItWorks />
      <Footer />
    </div>
  );
}
